// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AdminLayoutRouteImport } from './routes/_adminLayout'
import { Route as PartsAuthRouteImport } from './routes/_partsAuth'
import { Route as AboutRouteImport } from './routes/about'
import { Route as AboutUsRouteImport } from './routes/about-us'
import { Route as ApplicationCareerRouteImport } from './routes/application-career'
import { Route as BlogRouteImport } from './routes/blog'
import { Route as CampingClubRouteImport } from './routes/camping-club'
import { Route as CampingInWilmingtonNorthCarolinaRouteImport } from './routes/camping-in-wilmington-north-carolina'
import { Route as ChatSandboxRouteImport } from './routes/chat-sandbox'
import { Route as CindySandboxRouteImport } from './routes/cindy-sandbox'
import { Route as CommunityLoginRouteImport } from './routes/community-login'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as ContactUsRouteImport } from './routes/contact-us'
import { Route as ContactUsTradeInsRouteImport } from './routes/contact-us-trade-ins'
import { Route as DealOfTheWeekRouteImport } from './routes/deal-of-the-week'
import { Route as DestinationTrailersRouteImport } from './routes/destination-trailers'
import { Route as DoorPrizesRouteImport } from './routes/door-prizes'
import { Route as FifthWheelsRouteImport } from './routes/fifth-wheels'
import { Route as FinancingRouteImport } from './routes/financing'
import { Route as ForumRouteImport } from './routes/forum'
import { Route as GuideRouteImport } from './routes/guide'
import { Route as InventoryRouteImport } from './routes/inventory'
import { Route as KioskRouteImport } from './routes/kiosk'
import { Route as LoyaltyProgramRouteImport } from './routes/loyalty-program'
import { Route as MeetRexRouteImport } from './routes/meet-rex'
import { Route as MotorhomesRouteImport } from './routes/motorhomes'
import { Route as MyAccountRouteImport } from './routes/my-account'
import { Route as NcFreedomPopupDealerRouteImport } from './routes/nc-freedom-popup-dealer'
import { Route as NcPumaDealerRouteImport } from './routes/nc-puma-dealer'
import { Route as NewProductRouteImport } from './routes/new-product'
import { Route as NewRvsRouteImport } from './routes/new-rvs'
import { Route as PartsRouteImport } from './routes/parts'
import { Route as PartsCatalogRouteImport } from './routes/parts-catalog'
import { Route as PartsCatalogTestRouteImport } from './routes/parts-catalog-test'
import { Route as PartsCindySandboxRouteImport } from './routes/parts-cindy-sandbox'
import { Route as PartsPreviewRouteImport } from './routes/parts-preview'
import { Route as PartsRequestRouteImport } from './routes/parts-request'
import { Route as PaymentCalculatorRouteImport } from './routes/payment-calculator'
import { Route as PopUpCampersRouteImport } from './routes/pop-up-campers'
import { Route as PrivacyPolicyRouteImport } from './routes/privacy-policy'
import { Route as ProductEastToWestRouteImport } from './routes/product-east-to-west'
import { Route as ProductForestRiverRvRouteImport } from './routes/product-forest-river-rv'
import { Route as ProductIntechRvRouteImport } from './routes/product-intech-rv'
import { Route as ProductPalominoRouteImport } from './routes/product-palomino'
import { Route as ProductSunseekerRouteImport } from './routes/product-sunseeker'
import { Route as RaleighShowDrawingRouteImport } from './routes/raleigh-show-drawing'
import { Route as RentalsRouteImport } from './routes/rentals'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as Route66RvNetworkRouteImport } from './routes/route-66-rv-network'
import { Route as RvFinancingRouteImport } from './routes/rv-financing'
import { Route as RvHowToCheckYourRoofSeals1RouteImport } from './routes/rv-how-to-check-your-roof-seals-1'
import { Route as RvHowToWinterizeMyRvRouteImport } from './routes/rv-how-to-winterize-my-rv'
import { Route as RvManualsRouteImport } from './routes/rv-manuals'
import { Route as RvPartsRouteImport } from './routes/rv-parts'
import { Route as RvPreTripCheckListRouteImport } from './routes/rv-pre-trip-check-list'
import { Route as RvSearchRouteImport } from './routes/rv-search'
import { Route as RvSearchLabRouteImport } from './routes/rv-search-lab'
import { Route as RvServiceRouteImport } from './routes/rv-service'
import { Route as ScheduleAppointmentRouteImport } from './routes/schedule-appointment'
import { Route as SearchRouteImport } from './routes/search'
import { Route as SearchLabRouteImport } from './routes/search-lab'
import { Route as SellMyRvRouteImport } from './routes/sell-my-rv'
import { Route as SellYourRvRouteImport } from './routes/sell-your-rv'
import { Route as ServiceRouteImport } from './routes/service'
import { Route as ShopByBrandRouteImport } from './routes/shop-by-brand'
import { Route as ShopPartsRouteImport } from './routes/shop-parts'
import { Route as SpringRvExpoRouteImport } from './routes/spring-rv-expo'
import { Route as TestimonialsRouteImport } from './routes/testimonials'
import { Route as TowGuideRouteImport } from './routes/tow-guide'
import { Route as TowGuidesRouteImport } from './routes/tow-guides'
import { Route as ToyHaulersRouteImport } from './routes/toy-haulers'
import { Route as TravelTrailersRouteImport } from './routes/travel-trailers'
import { Route as UsedProductRouteImport } from './routes/used-product'
import { Route as UsedRvsRouteImport } from './routes/used-rvs'
import { Route as VideoGalleryRouteImport } from './routes/video-gallery'
import { Route as VideosRouteImport } from './routes/videos'
import { Route as WhyBuyAnRvRouteImport } from './routes/why-buy-an-rv'
import { Route as AdminCrm360RouteImport } from './routes/admin.crm360'
import { Route as AdminLoginRouteImport } from './routes/admin.login'
import { Route as BlogIndexRouteImport } from './routes/blog.index'
import { Route as BlogSlugRouteImport } from './routes/blog.$slug'
import { Route as BrochureTestSlugRouteImport } from './routes/brochure-test.$slug'
import { Route as ForumIndexRouteImport } from './routes/forum.index'
import { Route as ForumSlugRouteImport } from './routes/forum.$slug'
import { Route as GuideIndexRouteImport } from './routes/guide.index'
import { Route as GuideSlugRouteImport } from './routes/guide.$slug'
import { Route as InventorySlugRouteImport } from './routes/inventory.$slug'
import { Route as MyAccountIndexRouteImport } from './routes/my-account.index'
import { Route as MyAccountNotificationsRouteImport } from './routes/my-account.notifications'
import { Route as MyAccountProfileRouteImport } from './routes/my-account.profile'
import { Route as MyAccountRewardsRouteImport } from './routes/my-account.rewards'
import { Route as MyAccountRvsRouteImport } from './routes/my-account.rvs'
import { Route as MyAccountServiceRouteImport } from './routes/my-account.service'
import { Route as MyAccountWishlistRouteImport } from './routes/my-account.wishlist'
import { Route as NcFreedomPopupDealerIndexRouteImport } from './routes/nc-freedom-popup-dealer.index'
import { Route as NcFreedomPopupDealerSlugRouteImport } from './routes/nc-freedom-popup-dealer.$slug'
import { Route as NcPumaDealerIndexRouteImport } from './routes/nc-puma-dealer.index'
import { Route as NcPumaDealerSlugRouteImport } from './routes/nc-puma-dealer.$slug'
import { Route as NewProductIndexRouteImport } from './routes/new-product.index'
import { Route as NewProductTypeRouteImport } from './routes/new-product.$type'
import { Route as PSlugRouteImport } from './routes/p.$slug'
import { Route as PartsCatalogIndexRouteImport } from './routes/parts-catalog.index'
import { Route as PartsCatalogIdRouteImport } from './routes/parts-catalog.$id'
import { Route as PartsCatalogCartRouteImport } from './routes/parts-catalog.cart'
import { Route as PartsCatalogCategoriesRouteImport } from './routes/parts-catalog.categories'
import { Route as PartsCatalogCheckoutRouteImport } from './routes/parts-catalog.checkout'
import { Route as PartsCatalogManufacturersRouteImport } from './routes/parts-catalog.manufacturers'
import { Route as PartsCatalogPrivacyNoticeRouteImport } from './routes/parts-catalog.privacy-notice'
import { Route as PartsCatalogResultsRouteImport } from './routes/parts-catalog.results'
import { Route as PartsCatalogShippingReturnsRouteImport } from './routes/parts-catalog.shipping-returns'
import { Route as PartsCatalogUnsubscribeRouteImport } from './routes/parts-catalog.unsubscribe'
import { Route as PreviewHomeRouteImport } from './routes/preview.home'
import { Route as ProductEastToWestIndexRouteImport } from './routes/product-east-to-west.index'
import { Route as ProductEastToWestPathRouteImport } from './routes/product-east-to-west.$path'
import { Route as ProductForestRiverRvIndexRouteImport } from './routes/product-forest-river-rv.index'
import { Route as ProductForestRiverRvPathRouteImport } from './routes/product-forest-river-rv.$path'
import { Route as ProductIntechRvIndexRouteImport } from './routes/product-intech-rv.index'
import { Route as ProductIntechRvPathRouteImport } from './routes/product-intech-rv.$path'
import { Route as ProductPalominoIndexRouteImport } from './routes/product-palomino.index'
import { Route as ProductPalominoPathRouteImport } from './routes/product-palomino.$path'
import { Route as ProductSunseekerIndexRouteImport } from './routes/product-sunseeker.index'
import { Route as ProductSunseekerPathRouteImport } from './routes/product-sunseeker.$path'
import { Route as ProductSlugRouteImport } from './routes/product.$slug'
import { Route as ProductKioskRouteImport } from './routes/product.kiosk'
import { Route as ProductsSlugRouteImport } from './routes/products.$slug'
import { Route as ProducttagSlugRouteImport } from './routes/producttag.$slug'
import { Route as RvSearchIndexRouteImport } from './routes/rv-search.index'
import { Route as RvSearchSlugRouteImport } from './routes/rv-search.$slug'
import { Route as UsedProductIndexRouteImport } from './routes/used-product.index'
import { Route as UsedProductTypeRouteImport } from './routes/used-product.$type'
import { Route as VideosIndexRouteImport } from './routes/videos.index'
import { Route as VideosSlugRouteImport } from './routes/videos.$slug'
import { Route as AdminLayoutAdminIndexRouteImport } from './routes/_adminLayout.admin.index'
import { Route as AdminLayoutAdminAdsRouteImport } from './routes/_adminLayout.admin.ads'
import { Route as AdminLayoutAdminAppointmentsRouteImport } from './routes/_adminLayout.admin.appointments'
import { Route as AdminLayoutAdminBlogRouteImport } from './routes/_adminLayout.admin.blog'
import { Route as AdminLayoutAdminBuyersGuideRouteImport } from './routes/_adminLayout.admin.buyers-guide'
import { Route as AdminLayoutAdminCarmaxImagesRouteImport } from './routes/_adminLayout.admin.carmax-images'
import { Route as AdminLayoutAdminChatSandboxRouteImport } from './routes/_adminLayout.admin.chat-sandbox'
import { Route as AdminLayoutAdminChatsRouteImport } from './routes/_adminLayout.admin.chats'
import { Route as AdminLayoutAdminCrmRouteImport } from './routes/_adminLayout.admin.crm'
import { Route as AdminLayoutAdminCronJobsRouteImport } from './routes/_adminLayout.admin.cron-jobs'
import { Route as AdminLayoutAdminCustomerPortalRouteImport } from './routes/_adminLayout.admin.customer-portal'
import { Route as AdminLayoutAdminEmailRouteImport } from './routes/_adminLayout.admin.email'
import { Route as AdminLayoutAdminFeedDownloadsRouteImport } from './routes/_adminLayout.admin.feed-downloads'
import { Route as AdminLayoutAdminFeedImportRouteImport } from './routes/_adminLayout.admin.feed-import'
import { Route as AdminLayoutAdminFloorplanImportRouteImport } from './routes/_adminLayout.admin.floorplan-import'
import { Route as AdminLayoutAdminGuidesRouteImport } from './routes/_adminLayout.admin.guides'
import { Route as AdminLayoutAdminImageAuditRouteImport } from './routes/_adminLayout.admin.image-audit'
import { Route as AdminLayoutAdminInventoryRouteImport } from './routes/_adminLayout.admin.inventory'
import { Route as AdminLayoutAdminInventoryCleanSyncRouteImport } from './routes/_adminLayout.admin.inventory-clean-sync'
import { Route as AdminLayoutAdminInventoryStageSyncRouteImport } from './routes/_adminLayout.admin.inventory-stage-sync'
import { Route as AdminLayoutAdminKellerTestRouteImport } from './routes/_adminLayout.admin.keller-test'
import { Route as AdminLayoutAdminKeystoneDiscontinuedRouteImport } from './routes/_adminLayout.admin.keystone-discontinued'
import { Route as AdminLayoutAdminKioskRouteImport } from './routes/_adminLayout.admin.kiosk'
import { Route as AdminLayoutAdminLibraryRouteImport } from './routes/_adminLayout.admin.library'
import { Route as AdminLayoutAdminLoyaltyRouteImport } from './routes/_adminLayout.admin.loyalty'
import { Route as AdminLayoutAdminMarketingRouteImport } from './routes/_adminLayout.admin.marketing'
import { Route as AdminLayoutAdminMenuRouteImport } from './routes/_adminLayout.admin.menu'
import { Route as AdminLayoutAdminMicrositesRouteImport } from './routes/_adminLayout.admin.microsites'
import { Route as AdminLayoutAdminMssqlSyncRouteImport } from './routes/_adminLayout.admin.mssql-sync'
import { Route as AdminLayoutAdminNewslettersRouteImport } from './routes/_adminLayout.admin.newsletters'
import { Route as AdminLayoutAdminPagesRouteImport } from './routes/_adminLayout.admin.pages'
import { Route as AdminLayoutAdminPartsRouteImport } from './routes/_adminLayout.admin.parts'
import { Route as AdminLayoutAdminPartsFeedRouteImport } from './routes/_adminLayout.admin.parts-feed'
import { Route as AdminLayoutAdminPartsSearchTestRouteImport } from './routes/_adminLayout.admin.parts-search-test'
import { Route as AdminLayoutAdminPartsSyncRouteImport } from './routes/_adminLayout.admin.parts-sync'
import { Route as AdminLayoutAdminPricingRouteImport } from './routes/_adminLayout.admin.pricing'
import { Route as AdminLayoutAdminRedirectsRouteImport } from './routes/_adminLayout.admin.redirects'
import { Route as AdminLayoutAdminRentalsRouteImport } from './routes/_adminLayout.admin.rentals'
import { Route as AdminLayoutAdminReviewsRouteImport } from './routes/_adminLayout.admin.reviews'
import { Route as AdminLayoutAdminSalesPitchesRouteImport } from './routes/_adminLayout.admin.sales-pitches'
import { Route as AdminLayoutAdminSettingsRouteImport } from './routes/_adminLayout.admin.settings'
import { Route as AdminLayoutAdminStockPicturesRouteImport } from './routes/_adminLayout.admin.stock-pictures'
import { Route as AdminLayoutAdminStockPicturesReviewRouteImport } from './routes/_adminLayout.admin.stock-pictures-review'
import { Route as AdminLayoutAdminThemesRouteImport } from './routes/_adminLayout.admin.themes'
import { Route as AdminLayoutAdminUsersRouteImport } from './routes/_adminLayout.admin.users'
import { Route as AdminLayoutAdminVideoPagesRouteImport } from './routes/_adminLayout.admin.video-pages'
import { Route as NewProductTypeFeatureRouteImport } from './routes/new-product.$type.$feature'
import { Route as PartsCatalogAccountForgotPasswordRouteImport } from './routes/parts-catalog.account.forgot-password'
import { Route as PartsCatalogAccountLoginRouteImport } from './routes/parts-catalog.account.login'
import { Route as PartsCatalogAccountRegisterRouteImport } from './routes/parts-catalog.account.register'
import { Route as PartsCatalogAccountResetPasswordRouteImport } from './routes/parts-catalog.account.reset-password'
import { Route as PartsCatalogAccountVerifyRouteImport } from './routes/parts-catalog.account.verify'
import { Route as PartsCatalogCategorySlugRouteImport } from './routes/parts-catalog.category.$slug'
import { Route as PartsCatalogCheckoutIndexRouteImport } from './routes/parts-catalog.checkout.index'
import { Route as PartsCatalogDocsIdRouteImport } from './routes/parts-catalog.docs.$id'
import { Route as PartsCatalogManufacturerSlugRouteImport } from './routes/parts-catalog.manufacturer.$slug'
import { Route as PartsCatalogOrderOrderNumberRouteImport } from './routes/parts-catalog.order.$orderNumber'
import { Route as PartsCatalogPageSlugRouteImport } from './routes/parts-catalog.page.$slug'
import { Route as PartsCatalogQuoteTokenRouteImport } from './routes/parts-catalog.quote.$token'
import { Route as PreviewRvSlugRouteImport } from './routes/preview.rv.$slug'
import { Route as PrintStickerSlugRouteImport } from './routes/print.sticker.$slug'
import { Route as ProductEastToWestPathTrimRouteImport } from './routes/product-east-to-west.$path.$trim'
import { Route as ProductForestRiverRvPathTrimRouteImport } from './routes/product-forest-river-rv.$path.$trim'
import { Route as ProductIntechRvPathTrimRouteImport } from './routes/product-intech-rv.$path.$trim'
import { Route as ProductPalominoPathTrimRouteImport } from './routes/product-palomino.$path.$trim'
import { Route as ProductSunseekerPathTrimRouteImport } from './routes/product-sunseeker.$path.$trim'
import { Route as ProductSlugIndexRouteImport } from './routes/product.$slug.index'
import { Route as ProductSlugFeatureRouteImport } from './routes/product.$slug.$feature'
import { Route as UsedProductTypeFeatureRouteImport } from './routes/used-product.$type.$feature'
import { Route as AdminLayoutAdminPartsIndexRouteImport } from './routes/_adminLayout.admin.parts.index'
import { Route as AdminLayoutAdminPartsProductIdRouteImport } from './routes/_adminLayout.admin.parts.$productId'
import { Route as AdminLayoutAdminPartsCategoriesRouteImport } from './routes/_adminLayout.admin.parts.categories'
import { Route as AdminLayoutAdminPartsCategoryMapperRouteImport } from './routes/_adminLayout.admin.parts.category-mapper'
import { Route as AdminLayoutAdminPartsChatsRouteImport } from './routes/_adminLayout.admin.parts.chats'
import { Route as AdminLayoutAdminPartsContentRouteImport } from './routes/_adminLayout.admin.parts.content'
import { Route as AdminLayoutAdminPartsCrmRouteImport } from './routes/_adminLayout.admin.parts.crm'
import { Route as AdminLayoutAdminPartsCustomersRouteImport } from './routes/_adminLayout.admin.parts.customers'
import { Route as AdminLayoutAdminPartsDiscountsRouteImport } from './routes/_adminLayout.admin.parts.discounts'
import { Route as AdminLayoutAdminPartsDistributorsRouteImport } from './routes/_adminLayout.admin.parts.distributors'
import { Route as AdminLayoutAdminPartsEmailsRouteImport } from './routes/_adminLayout.admin.parts.emails'
import { Route as AdminLayoutAdminPartsFeedImportRouteImport } from './routes/_adminLayout.admin.parts.feed-import'
import { Route as AdminLayoutAdminPartsMainCategoriesRouteImport } from './routes/_adminLayout.admin.parts.main-categories'
import { Route as AdminLayoutAdminPartsManufacturersRouteImport } from './routes/_adminLayout.admin.parts.manufacturers'
import { Route as AdminLayoutAdminPartsMessagesRouteImport } from './routes/_adminLayout.admin.parts.messages'
import { Route as AdminLayoutAdminPartsNewsRouteImport } from './routes/_adminLayout.admin.parts.news'
import { Route as AdminLayoutAdminPartsOrdersRouteImport } from './routes/_adminLayout.admin.parts.orders'
import { Route as AdminLayoutAdminPartsQuotesRouteImport } from './routes/_adminLayout.admin.parts.quotes'
import { Route as AdminLayoutAdminPartsRequestsRouteImport } from './routes/_adminLayout.admin.parts.requests'
import { Route as AdminLayoutAdminPartsReviewsRouteImport } from './routes/_adminLayout.admin.parts.reviews'
import { Route as AdminLayoutAdminPartsShipmentsRouteImport } from './routes/_adminLayout.admin.parts.shipments'
import { Route as AdminLayoutAdminPartsStorefrontRouteImport } from './routes/_adminLayout.admin.parts.storefront'
import { Route as AdminLayoutAdminPartsTasksRouteImport } from './routes/_adminLayout.admin.parts.tasks'
import { Route as AdminLayoutAdminPartsTaxRatesRouteImport } from './routes/_adminLayout.admin.parts.tax-rates'
import { Route as AdminLayoutAdminPartsTemplateRouteImport } from './routes/_adminLayout.admin.parts.template'
import { Route as PartsAuthPartsCatalogAccountIndexRouteImport } from './routes/_partsAuth.parts-catalog.account.index'
import { Route as PartsAuthPartsCatalogAccountAddressesRouteImport } from './routes/_partsAuth.parts-catalog.account.addresses'
import { Route as PartsAuthPartsCatalogAccountChangePasswordRouteImport } from './routes/_partsAuth.parts-catalog.account.change-password'
import { Route as PartsAuthPartsCatalogAccountOrdersRouteImport } from './routes/_partsAuth.parts-catalog.account.orders'
import { Route as PartsCatalogCheckoutConfirmationOrderNumberRouteImport } from './routes/parts-catalog.checkout.confirmation.$orderNumber'
import { Route as AdminLayoutAdminPartsCategoriesIndexRouteImport } from './routes/_adminLayout.admin.parts.categories.index'
import { Route as AdminLayoutAdminPartsCategoriesBasicCategoryRouteImport } from './routes/_adminLayout.admin.parts.categories.$basicCategory'
import { Route as AdminLayoutAdminPartsContentIndexRouteImport } from './routes/_adminLayout.admin.parts.content.index'
import { Route as AdminLayoutAdminPartsContentIdRouteImport } from './routes/_adminLayout.admin.parts.content.$id'
import { Route as AdminLayoutAdminPartsContentNewRouteImport } from './routes/_adminLayout.admin.parts.content.new'
import { Route as AdminLayoutAdminPartsCustomersIndexRouteImport } from './routes/_adminLayout.admin.parts.customers.index'
import { Route as AdminLayoutAdminPartsCustomersIdRouteImport } from './routes/_adminLayout.admin.parts.customers.$id'
import { Route as AdminLayoutAdminPartsDiscountsIndexRouteImport } from './routes/_adminLayout.admin.parts.discounts.index'
import { Route as AdminLayoutAdminPartsDiscountsIdRouteImport } from './routes/_adminLayout.admin.parts.discounts.$id'
import { Route as AdminLayoutAdminPartsDistributorsIndexRouteImport } from './routes/_adminLayout.admin.parts.distributors.index'
import { Route as AdminLayoutAdminPartsDistributorsIdRouteImport } from './routes/_adminLayout.admin.parts.distributors.$id'
import { Route as AdminLayoutAdminPartsDistributorsNewRouteImport } from './routes/_adminLayout.admin.parts.distributors.new'
import { Route as AdminLayoutAdminPartsManufacturersIndexRouteImport } from './routes/_adminLayout.admin.parts.manufacturers.index'
import { Route as AdminLayoutAdminPartsManufacturersVendorIdRouteImport } from './routes/_adminLayout.admin.parts.manufacturers.$vendorId'
import { Route as AdminLayoutAdminPartsMessagesIndexRouteImport } from './routes/_adminLayout.admin.parts.messages.index'
import { Route as AdminLayoutAdminPartsMessagesIdRouteImport } from './routes/_adminLayout.admin.parts.messages.$id'
import { Route as AdminLayoutAdminPartsNewsIndexRouteImport } from './routes/_adminLayout.admin.parts.news.index'
import { Route as AdminLayoutAdminPartsNewsIdRouteImport } from './routes/_adminLayout.admin.parts.news.$id'
import { Route as AdminLayoutAdminPartsOrdersIndexRouteImport } from './routes/_adminLayout.admin.parts.orders.index'
import { Route as AdminLayoutAdminPartsOrdersIdRouteImport } from './routes/_adminLayout.admin.parts.orders.$id'
import { Route as AdminLayoutAdminPartsShipmentsIndexRouteImport } from './routes/_adminLayout.admin.parts.shipments.index'
import { Route as AdminLayoutAdminPartsShipmentsIdRouteImport } from './routes/_adminLayout.admin.parts.shipments.$id'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AdminLayoutRoute = AdminLayoutRouteImport.update({
            id: '/_adminLayout',getParentRoute: () => rootRouteImport
          })
const PartsAuthRoute = PartsAuthRouteImport.update({
            id: '/_partsAuth',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const AboutUsRoute = AboutUsRouteImport.update({
            id: '/about-us',path: '/about-us',getParentRoute: () => rootRouteImport
          })
const ApplicationCareerRoute = ApplicationCareerRouteImport.update({
            id: '/application-career',path: '/application-career',getParentRoute: () => rootRouteImport
          })
const BlogRoute = BlogRouteImport.update({
            id: '/blog',path: '/blog',getParentRoute: () => rootRouteImport
          })
const CampingClubRoute = CampingClubRouteImport.update({
            id: '/camping-club',path: '/camping-club',getParentRoute: () => rootRouteImport
          })
const CampingInWilmingtonNorthCarolinaRoute = CampingInWilmingtonNorthCarolinaRouteImport.update({
            id: '/camping-in-wilmington-north-carolina',path: '/camping-in-wilmington-north-carolina',getParentRoute: () => rootRouteImport
          })
const ChatSandboxRoute = ChatSandboxRouteImport.update({
            id: '/chat-sandbox',path: '/chat-sandbox',getParentRoute: () => rootRouteImport
          })
const CindySandboxRoute = CindySandboxRouteImport.update({
            id: '/cindy-sandbox',path: '/cindy-sandbox',getParentRoute: () => rootRouteImport
          })
const CommunityLoginRoute = CommunityLoginRouteImport.update({
            id: '/community-login',path: '/community-login',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const ContactUsRoute = ContactUsRouteImport.update({
            id: '/contact-us',path: '/contact-us',getParentRoute: () => rootRouteImport
          })
const ContactUsTradeInsRoute = ContactUsTradeInsRouteImport.update({
            id: '/contact-us-trade-ins',path: '/contact-us-trade-ins',getParentRoute: () => rootRouteImport
          })
const DealOfTheWeekRoute = DealOfTheWeekRouteImport.update({
            id: '/deal-of-the-week',path: '/deal-of-the-week',getParentRoute: () => rootRouteImport
          })
const DestinationTrailersRoute = DestinationTrailersRouteImport.update({
            id: '/destination-trailers',path: '/destination-trailers',getParentRoute: () => rootRouteImport
          })
const DoorPrizesRoute = DoorPrizesRouteImport.update({
            id: '/door-prizes',path: '/door-prizes',getParentRoute: () => rootRouteImport
          })
const FifthWheelsRoute = FifthWheelsRouteImport.update({
            id: '/fifth-wheels',path: '/fifth-wheels',getParentRoute: () => rootRouteImport
          })
const FinancingRoute = FinancingRouteImport.update({
            id: '/financing',path: '/financing',getParentRoute: () => rootRouteImport
          })
const ForumRoute = ForumRouteImport.update({
            id: '/forum',path: '/forum',getParentRoute: () => rootRouteImport
          })
const GuideRoute = GuideRouteImport.update({
            id: '/guide',path: '/guide',getParentRoute: () => rootRouteImport
          })
const InventoryRoute = InventoryRouteImport.update({
            id: '/inventory',path: '/inventory',getParentRoute: () => rootRouteImport
          })
const KioskRoute = KioskRouteImport.update({
            id: '/kiosk',path: '/kiosk',getParentRoute: () => rootRouteImport
          })
const LoyaltyProgramRoute = LoyaltyProgramRouteImport.update({
            id: '/loyalty-program',path: '/loyalty-program',getParentRoute: () => rootRouteImport
          })
const MeetRexRoute = MeetRexRouteImport.update({
            id: '/meet-rex',path: '/meet-rex',getParentRoute: () => rootRouteImport
          })
const MotorhomesRoute = MotorhomesRouteImport.update({
            id: '/motorhomes',path: '/motorhomes',getParentRoute: () => rootRouteImport
          })
const MyAccountRoute = MyAccountRouteImport.update({
            id: '/my-account',path: '/my-account',getParentRoute: () => rootRouteImport
          })
const NcFreedomPopupDealerRoute = NcFreedomPopupDealerRouteImport.update({
            id: '/nc-freedom-popup-dealer',path: '/nc-freedom-popup-dealer',getParentRoute: () => rootRouteImport
          })
const NcPumaDealerRoute = NcPumaDealerRouteImport.update({
            id: '/nc-puma-dealer',path: '/nc-puma-dealer',getParentRoute: () => rootRouteImport
          })
const NewProductRoute = NewProductRouteImport.update({
            id: '/new-product',path: '/new-product',getParentRoute: () => rootRouteImport
          })
const NewRvsRoute = NewRvsRouteImport.update({
            id: '/new-rvs',path: '/new-rvs',getParentRoute: () => rootRouteImport
          })
const PartsRoute = PartsRouteImport.update({
            id: '/parts',path: '/parts',getParentRoute: () => rootRouteImport
          })
const PartsCatalogRoute = PartsCatalogRouteImport.update({
            id: '/parts-catalog',path: '/parts-catalog',getParentRoute: () => rootRouteImport
          })
const PartsCatalogTestRoute = PartsCatalogTestRouteImport.update({
            id: '/parts-catalog-test',path: '/parts-catalog-test',getParentRoute: () => rootRouteImport
          })
const PartsCindySandboxRoute = PartsCindySandboxRouteImport.update({
            id: '/parts-cindy-sandbox',path: '/parts-cindy-sandbox',getParentRoute: () => rootRouteImport
          })
const PartsPreviewRoute = PartsPreviewRouteImport.update({
            id: '/parts-preview',path: '/parts-preview',getParentRoute: () => rootRouteImport
          })
const PartsRequestRoute = PartsRequestRouteImport.update({
            id: '/parts-request',path: '/parts-request',getParentRoute: () => rootRouteImport
          })
const PaymentCalculatorRoute = PaymentCalculatorRouteImport.update({
            id: '/payment-calculator',path: '/payment-calculator',getParentRoute: () => rootRouteImport
          })
const PopUpCampersRoute = PopUpCampersRouteImport.update({
            id: '/pop-up-campers',path: '/pop-up-campers',getParentRoute: () => rootRouteImport
          })
const PrivacyPolicyRoute = PrivacyPolicyRouteImport.update({
            id: '/privacy-policy',path: '/privacy-policy',getParentRoute: () => rootRouteImport
          })
const ProductEastToWestRoute = ProductEastToWestRouteImport.update({
            id: '/product-east-to-west',path: '/product-east-to-west',getParentRoute: () => rootRouteImport
          })
const ProductForestRiverRvRoute = ProductForestRiverRvRouteImport.update({
            id: '/product-forest-river-rv',path: '/product-forest-river-rv',getParentRoute: () => rootRouteImport
          })
const ProductIntechRvRoute = ProductIntechRvRouteImport.update({
            id: '/product-intech-rv',path: '/product-intech-rv',getParentRoute: () => rootRouteImport
          })
const ProductPalominoRoute = ProductPalominoRouteImport.update({
            id: '/product-palomino',path: '/product-palomino',getParentRoute: () => rootRouteImport
          })
const ProductSunseekerRoute = ProductSunseekerRouteImport.update({
            id: '/product-sunseeker',path: '/product-sunseeker',getParentRoute: () => rootRouteImport
          })
const RaleighShowDrawingRoute = RaleighShowDrawingRouteImport.update({
            id: '/raleigh-show-drawing',path: '/raleigh-show-drawing',getParentRoute: () => rootRouteImport
          })
const RentalsRoute = RentalsRouteImport.update({
            id: '/rentals',path: '/rentals',getParentRoute: () => rootRouteImport
          })
const ResetPasswordRoute = ResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => rootRouteImport
          })
const Route66RvNetworkRoute = Route66RvNetworkRouteImport.update({
            id: '/route-66-rv-network',path: '/route-66-rv-network',getParentRoute: () => rootRouteImport
          })
const RvFinancingRoute = RvFinancingRouteImport.update({
            id: '/rv-financing',path: '/rv-financing',getParentRoute: () => rootRouteImport
          })
const RvHowToCheckYourRoofSeals1Route = RvHowToCheckYourRoofSeals1RouteImport.update({
            id: '/rv-how-to-check-your-roof-seals-1',path: '/rv-how-to-check-your-roof-seals-1',getParentRoute: () => rootRouteImport
          })
const RvHowToWinterizeMyRvRoute = RvHowToWinterizeMyRvRouteImport.update({
            id: '/rv-how-to-winterize-my-rv',path: '/rv-how-to-winterize-my-rv',getParentRoute: () => rootRouteImport
          })
const RvManualsRoute = RvManualsRouteImport.update({
            id: '/rv-manuals',path: '/rv-manuals',getParentRoute: () => rootRouteImport
          })
const RvPartsRoute = RvPartsRouteImport.update({
            id: '/rv-parts',path: '/rv-parts',getParentRoute: () => rootRouteImport
          })
const RvPreTripCheckListRoute = RvPreTripCheckListRouteImport.update({
            id: '/rv-pre-trip-check-list',path: '/rv-pre-trip-check-list',getParentRoute: () => rootRouteImport
          })
const RvSearchRoute = RvSearchRouteImport.update({
            id: '/rv-search',path: '/rv-search',getParentRoute: () => rootRouteImport
          })
const RvSearchLabRoute = RvSearchLabRouteImport.update({
            id: '/rv-search-lab',path: '/rv-search-lab',getParentRoute: () => rootRouteImport
          })
const RvServiceRoute = RvServiceRouteImport.update({
            id: '/rv-service',path: '/rv-service',getParentRoute: () => rootRouteImport
          })
const ScheduleAppointmentRoute = ScheduleAppointmentRouteImport.update({
            id: '/schedule-appointment',path: '/schedule-appointment',getParentRoute: () => rootRouteImport
          })
const SearchRoute = SearchRouteImport.update({
            id: '/search',path: '/search',getParentRoute: () => rootRouteImport
          })
const SearchLabRoute = SearchLabRouteImport.update({
            id: '/search-lab',path: '/search-lab',getParentRoute: () => rootRouteImport
          })
const SellMyRvRoute = SellMyRvRouteImport.update({
            id: '/sell-my-rv',path: '/sell-my-rv',getParentRoute: () => rootRouteImport
          })
const SellYourRvRoute = SellYourRvRouteImport.update({
            id: '/sell-your-rv',path: '/sell-your-rv',getParentRoute: () => rootRouteImport
          })
const ServiceRoute = ServiceRouteImport.update({
            id: '/service',path: '/service',getParentRoute: () => rootRouteImport
          })
const ShopByBrandRoute = ShopByBrandRouteImport.update({
            id: '/shop-by-brand',path: '/shop-by-brand',getParentRoute: () => rootRouteImport
          })
const ShopPartsRoute = ShopPartsRouteImport.update({
            id: '/shop-parts',path: '/shop-parts',getParentRoute: () => rootRouteImport
          })
const SpringRvExpoRoute = SpringRvExpoRouteImport.update({
            id: '/spring-rv-expo',path: '/spring-rv-expo',getParentRoute: () => rootRouteImport
          })
const TestimonialsRoute = TestimonialsRouteImport.update({
            id: '/testimonials',path: '/testimonials',getParentRoute: () => rootRouteImport
          })
const TowGuideRoute = TowGuideRouteImport.update({
            id: '/tow-guide',path: '/tow-guide',getParentRoute: () => rootRouteImport
          })
const TowGuidesRoute = TowGuidesRouteImport.update({
            id: '/tow-guides',path: '/tow-guides',getParentRoute: () => rootRouteImport
          })
const ToyHaulersRoute = ToyHaulersRouteImport.update({
            id: '/toy-haulers',path: '/toy-haulers',getParentRoute: () => rootRouteImport
          })
const TravelTrailersRoute = TravelTrailersRouteImport.update({
            id: '/travel-trailers',path: '/travel-trailers',getParentRoute: () => rootRouteImport
          })
const UsedProductRoute = UsedProductRouteImport.update({
            id: '/used-product',path: '/used-product',getParentRoute: () => rootRouteImport
          })
const UsedRvsRoute = UsedRvsRouteImport.update({
            id: '/used-rvs',path: '/used-rvs',getParentRoute: () => rootRouteImport
          })
const VideoGalleryRoute = VideoGalleryRouteImport.update({
            id: '/video-gallery',path: '/video-gallery',getParentRoute: () => rootRouteImport
          })
const VideosRoute = VideosRouteImport.update({
            id: '/videos',path: '/videos',getParentRoute: () => rootRouteImport
          })
const WhyBuyAnRvRoute = WhyBuyAnRvRouteImport.update({
            id: '/why-buy-an-rv',path: '/why-buy-an-rv',getParentRoute: () => rootRouteImport
          })
const AdminCrm360Route = AdminCrm360RouteImport.update({
            id: '/admin/crm360',path: '/admin/crm360',getParentRoute: () => rootRouteImport
          })
const AdminLoginRoute = AdminLoginRouteImport.update({
            id: '/admin/login',path: '/admin/login',getParentRoute: () => rootRouteImport
          })
const BlogIndexRoute = BlogIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => BlogRoute
          })
const BlogSlugRoute = BlogSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => BlogRoute
          })
const BrochureTestSlugRoute = BrochureTestSlugRouteImport.update({
            id: '/brochure-test/$slug',path: '/brochure-test/$slug',getParentRoute: () => rootRouteImport
          })
const ForumIndexRoute = ForumIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => ForumRoute
          })
const ForumSlugRoute = ForumSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => ForumRoute
          })
const GuideIndexRoute = GuideIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => GuideRoute
          })
const GuideSlugRoute = GuideSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => GuideRoute
          })
const InventorySlugRoute = InventorySlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => InventoryRoute
          })
const MyAccountIndexRoute = MyAccountIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => MyAccountRoute
          })
const MyAccountNotificationsRoute = MyAccountNotificationsRouteImport.update({
            id: '/notifications',path: '/notifications',getParentRoute: () => MyAccountRoute
          })
const MyAccountProfileRoute = MyAccountProfileRouteImport.update({
            id: '/profile',path: '/profile',getParentRoute: () => MyAccountRoute
          })
const MyAccountRewardsRoute = MyAccountRewardsRouteImport.update({
            id: '/rewards',path: '/rewards',getParentRoute: () => MyAccountRoute
          })
const MyAccountRvsRoute = MyAccountRvsRouteImport.update({
            id: '/rvs',path: '/rvs',getParentRoute: () => MyAccountRoute
          })
const MyAccountServiceRoute = MyAccountServiceRouteImport.update({
            id: '/service',path: '/service',getParentRoute: () => MyAccountRoute
          })
const MyAccountWishlistRoute = MyAccountWishlistRouteImport.update({
            id: '/wishlist',path: '/wishlist',getParentRoute: () => MyAccountRoute
          })
const NcFreedomPopupDealerIndexRoute = NcFreedomPopupDealerIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => NcFreedomPopupDealerRoute
          })
const NcFreedomPopupDealerSlugRoute = NcFreedomPopupDealerSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => NcFreedomPopupDealerRoute
          })
const NcPumaDealerIndexRoute = NcPumaDealerIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => NcPumaDealerRoute
          })
const NcPumaDealerSlugRoute = NcPumaDealerSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => NcPumaDealerRoute
          })
const NewProductIndexRoute = NewProductIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => NewProductRoute
          })
const NewProductTypeRoute = NewProductTypeRouteImport.update({
            id: '/$type',path: '/$type',getParentRoute: () => NewProductRoute
          })
const PSlugRoute = PSlugRouteImport.update({
            id: '/p/$slug',path: '/p/$slug',getParentRoute: () => rootRouteImport
          })
const PartsCatalogIndexRoute = PartsCatalogIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => PartsCatalogRoute
          })
const PartsCatalogIdRoute = PartsCatalogIdRouteImport.update({
            id: '/$id',path: '/$id',getParentRoute: () => PartsCatalogRoute
          })
const PartsCatalogCartRoute = PartsCatalogCartRouteImport.update({
            id: '/cart',path: '/cart',getParentRoute: () => PartsCatalogRoute
          })
const PartsCatalogCategoriesRoute = PartsCatalogCategoriesRouteImport.update({
            id: '/categories',path: '/categories',getParentRoute: () => PartsCatalogRoute
          })
const PartsCatalogCheckoutRoute = PartsCatalogCheckoutRouteImport.update({
            id: '/checkout',path: '/checkout',getParentRoute: () => PartsCatalogRoute
          })
const PartsCatalogManufacturersRoute = PartsCatalogManufacturersRouteImport.update({
            id: '/manufacturers',path: '/manufacturers',getParentRoute: () => PartsCatalogRoute
          })
const PartsCatalogPrivacyNoticeRoute = PartsCatalogPrivacyNoticeRouteImport.update({
            id: '/privacy-notice',path: '/privacy-notice',getParentRoute: () => PartsCatalogRoute
          })
const PartsCatalogResultsRoute = PartsCatalogResultsRouteImport.update({
            id: '/results',path: '/results',getParentRoute: () => PartsCatalogRoute
          })
const PartsCatalogShippingReturnsRoute = PartsCatalogShippingReturnsRouteImport.update({
            id: '/shipping-returns',path: '/shipping-returns',getParentRoute: () => PartsCatalogRoute
          })
const PartsCatalogUnsubscribeRoute = PartsCatalogUnsubscribeRouteImport.update({
            id: '/unsubscribe',path: '/unsubscribe',getParentRoute: () => PartsCatalogRoute
          })
const PreviewHomeRoute = PreviewHomeRouteImport.update({
            id: '/preview/home',path: '/preview/home',getParentRoute: () => rootRouteImport
          })
const ProductEastToWestIndexRoute = ProductEastToWestIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => ProductEastToWestRoute
          })
const ProductEastToWestPathRoute = ProductEastToWestPathRouteImport.update({
            id: '/$path',path: '/$path',getParentRoute: () => ProductEastToWestRoute
          })
const ProductForestRiverRvIndexRoute = ProductForestRiverRvIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => ProductForestRiverRvRoute
          })
const ProductForestRiverRvPathRoute = ProductForestRiverRvPathRouteImport.update({
            id: '/$path',path: '/$path',getParentRoute: () => ProductForestRiverRvRoute
          })
const ProductIntechRvIndexRoute = ProductIntechRvIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => ProductIntechRvRoute
          })
const ProductIntechRvPathRoute = ProductIntechRvPathRouteImport.update({
            id: '/$path',path: '/$path',getParentRoute: () => ProductIntechRvRoute
          })
const ProductPalominoIndexRoute = ProductPalominoIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => ProductPalominoRoute
          })
const ProductPalominoPathRoute = ProductPalominoPathRouteImport.update({
            id: '/$path',path: '/$path',getParentRoute: () => ProductPalominoRoute
          })
const ProductSunseekerIndexRoute = ProductSunseekerIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => ProductSunseekerRoute
          })
const ProductSunseekerPathRoute = ProductSunseekerPathRouteImport.update({
            id: '/$path',path: '/$path',getParentRoute: () => ProductSunseekerRoute
          })
const ProductSlugRoute = ProductSlugRouteImport.update({
            id: '/product/$slug',path: '/product/$slug',getParentRoute: () => rootRouteImport
          })
const ProductKioskRoute = ProductKioskRouteImport.update({
            id: '/product/kiosk',path: '/product/kiosk',getParentRoute: () => rootRouteImport
          })
const ProductsSlugRoute = ProductsSlugRouteImport.update({
            id: '/products/$slug',path: '/products/$slug',getParentRoute: () => rootRouteImport
          })
const ProducttagSlugRoute = ProducttagSlugRouteImport.update({
            id: '/producttag/$slug',path: '/producttag/$slug',getParentRoute: () => rootRouteImport
          })
const RvSearchIndexRoute = RvSearchIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => RvSearchRoute
          })
const RvSearchSlugRoute = RvSearchSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => RvSearchRoute
          })
const UsedProductIndexRoute = UsedProductIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => UsedProductRoute
          })
const UsedProductTypeRoute = UsedProductTypeRouteImport.update({
            id: '/$type',path: '/$type',getParentRoute: () => UsedProductRoute
          })
const VideosIndexRoute = VideosIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => VideosRoute
          })
const VideosSlugRoute = VideosSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => VideosRoute
          })
const AdminLayoutAdminIndexRoute = AdminLayoutAdminIndexRouteImport.update({
            id: '/admin/',path: '/admin/',getParentRoute: () => AdminLayoutRoute
          })
const AdminLayoutAdminAdsRoute = AdminLayoutAdminAdsRouteImport.update({
            id: '/admin/ads',path: '/admin/ads',getParentRoute: () => AdminLayoutRoute
          })
const AdminLayoutAdminAppointmentsRoute = AdminLayoutAdminAppointmentsRouteImport.update({
            id: '/admin/appointments',path: '/admin/appointments',getParentRoute: () => AdminLayoutRoute
          })
const AdminLayoutAdminBlogRoute = AdminLayoutAdminBlogRouteImport.update({
            id: '/admin/blog',path: '/admin/blog',getParentRoute: () => AdminLayoutRoute
          })
const AdminLayoutAdminBuyersGuideRoute = AdminLayoutAdminBuyersGuideRouteImport.update({
            id: '/admin/buyers-guide',path: '/admin/buyers-guide',getParentRoute: () => AdminLayoutRoute
          })
const AdminLayoutAdminCarmaxImagesRoute = AdminLayoutAdminCarmaxImagesRouteImport.update({
            id: '/admin/carmax-images',path: '/admin/carmax-images',getParentRoute: () => AdminLayoutRoute
          })
const AdminLayoutAdminChatSandboxRoute = AdminLayoutAdminChatSandboxRouteImport.update({
            id: '/admin/chat-sandbox',path: '/admin/chat-sandbox',getParentRoute: () => AdminLayoutRoute
          })
const AdminLayoutAdminChatsRoute = AdminLayoutAdminChatsRouteImport.update({
            id: '/admin/chats',path: '/admin/chats',getParentRoute: () => AdminLayoutRoute
          })
const AdminLayoutAdminCrmRoute = AdminLayoutAdminCrmRouteImport.update({
            id: '/admin/crm',path: '/admin/crm',getParentRoute: () => AdminLayoutRoute
          })
const AdminLayoutAdminCronJobsRoute = AdminLayoutAdminCronJobsRouteImport.update({
            id: '/admin/cron-jobs',path: '/admin/cron-jobs',getParentRoute: () => AdminLayoutRoute
          })
const AdminLayoutAdminCustomerPortalRoute = AdminLayoutAdminCustomerPortalRouteImport.update({
            id: '/admin/customer-portal',path: '/admin/customer-portal',getParentRoute: () => AdminLayoutRoute
          })
const AdminLayoutAdminEmailRoute = AdminLayoutAdminEmailRouteImport.update({
            id: '/admin/email',path: '/admin/email',getParentRoute: () => AdminLayoutRoute
          })
const AdminLayoutAdminFeedDownloadsRoute = AdminLayoutAdminFeedDownloadsRouteImport.update({
            id: '/admin/feed-downloads',path: '/admin/feed-downloads',getParentRoute: () => AdminLayoutRoute
          })
const AdminLayoutAdminFeedImportRoute = AdminLayoutAdminFeedImportRouteImport.update({
            id: '/admin/feed-import',path: '/admin/feed-import',getParentRoute: () => AdminLayoutRoute
          })
const AdminLayoutAdminFloorplanImportRoute = AdminLayoutAdminFloorplanImportRouteImport.update({
            id: '/admin/floorplan-import',path: '/admin/floorplan-import',getParentRoute: () => AdminLayoutRoute
          })
const AdminLayoutAdminGuidesRoute = AdminLayoutAdminGuidesRouteImport.update({
            id: '/admin/guides',path: '/admin/guides',getParentRoute: () => AdminLayoutRoute
          })
const AdminLayoutAdminImageAuditRoute = AdminLayoutAdminImageAuditRouteImport.update({
            id: '/admin/image-audit',path: '/admin/image-audit',getParentRoute: () => AdminLayoutRoute
          })
const AdminLayoutAdminInventoryRoute = AdminLayoutAdminInventoryRouteImport.update({
            id: '/admin/inventory',path: '/admin/inventory',getParentRoute: () => AdminLayoutRoute
          })
const AdminLayoutAdminInventoryCleanSyncRoute = AdminLayoutAdminInventoryCleanSyncRouteImport.update({
            id: '/admin/inventory-clean-sync',path: '/admin/inventory-clean-sync',getParentRoute: () => AdminLayoutRoute
          })
const AdminLayoutAdminInventoryStageSyncRoute = AdminLayoutAdminInventoryStageSyncRouteImport.update({
            id: '/admin/inventory-stage-sync',path: '/admin/inventory-stage-sync',getParentRoute: () => AdminLayoutRoute
          })
const AdminLayoutAdminKellerTestRoute = AdminLayoutAdminKellerTestRouteImport.update({
            id: '/admin/keller-test',path: '/admin/keller-test',getParentRoute: () => AdminLayoutRoute
          })
const AdminLayoutAdminKeystoneDiscontinuedRoute = AdminLayoutAdminKeystoneDiscontinuedRouteImport.update({
            id: '/admin/keystone-discontinued',path: '/admin/keystone-discontinued',getParentRoute: () => AdminLayoutRoute
          })
const AdminLayoutAdminKioskRoute = AdminLayoutAdminKioskRouteImport.update({
            id: '/admin/kiosk',path: '/admin/kiosk',getParentRoute: () => AdminLayoutRoute
          })
const AdminLayoutAdminLibraryRoute = AdminLayoutAdminLibraryRouteImport.update({
            id: '/admin/library',path: '/admin/library',getParentRoute: () => AdminLayoutRoute
          })
const AdminLayoutAdminLoyaltyRoute = AdminLayoutAdminLoyaltyRouteImport.update({
            id: '/admin/loyalty',path: '/admin/loyalty',getParentRoute: () => AdminLayoutRoute
          })
const AdminLayoutAdminMarketingRoute = AdminLayoutAdminMarketingRouteImport.update({
            id: '/admin/marketing',path: '/admin/marketing',getParentRoute: () => AdminLayoutRoute
          })
const AdminLayoutAdminMenuRoute = AdminLayoutAdminMenuRouteImport.update({
            id: '/admin/menu',path: '/admin/menu',getParentRoute: () => AdminLayoutRoute
          })
const AdminLayoutAdminMicrositesRoute = AdminLayoutAdminMicrositesRouteImport.update({
            id: '/admin/microsites',path: '/admin/microsites',getParentRoute: () => AdminLayoutRoute
          })
const AdminLayoutAdminMssqlSyncRoute = AdminLayoutAdminMssqlSyncRouteImport.update({
            id: '/admin/mssql-sync',path: '/admin/mssql-sync',getParentRoute: () => AdminLayoutRoute
          })
const AdminLayoutAdminNewslettersRoute = AdminLayoutAdminNewslettersRouteImport.update({
            id: '/admin/newsletters',path: '/admin/newsletters',getParentRoute: () => AdminLayoutRoute
          })
const AdminLayoutAdminPagesRoute = AdminLayoutAdminPagesRouteImport.update({
            id: '/admin/pages',path: '/admin/pages',getParentRoute: () => AdminLayoutRoute
          })
const AdminLayoutAdminPartsRoute = AdminLayoutAdminPartsRouteImport.update({
            id: '/admin/parts',path: '/admin/parts',getParentRoute: () => AdminLayoutRoute
          })
const AdminLayoutAdminPartsFeedRoute = AdminLayoutAdminPartsFeedRouteImport.update({
            id: '/admin/parts-feed',path: '/admin/parts-feed',getParentRoute: () => AdminLayoutRoute
          })
const AdminLayoutAdminPartsSearchTestRoute = AdminLayoutAdminPartsSearchTestRouteImport.update({
            id: '/admin/parts-search-test',path: '/admin/parts-search-test',getParentRoute: () => AdminLayoutRoute
          })
const AdminLayoutAdminPartsSyncRoute = AdminLayoutAdminPartsSyncRouteImport.update({
            id: '/admin/parts-sync',path: '/admin/parts-sync',getParentRoute: () => AdminLayoutRoute
          })
const AdminLayoutAdminPricingRoute = AdminLayoutAdminPricingRouteImport.update({
            id: '/admin/pricing',path: '/admin/pricing',getParentRoute: () => AdminLayoutRoute
          })
const AdminLayoutAdminRedirectsRoute = AdminLayoutAdminRedirectsRouteImport.update({
            id: '/admin/redirects',path: '/admin/redirects',getParentRoute: () => AdminLayoutRoute
          })
const AdminLayoutAdminRentalsRoute = AdminLayoutAdminRentalsRouteImport.update({
            id: '/admin/rentals',path: '/admin/rentals',getParentRoute: () => AdminLayoutRoute
          })
const AdminLayoutAdminReviewsRoute = AdminLayoutAdminReviewsRouteImport.update({
            id: '/admin/reviews',path: '/admin/reviews',getParentRoute: () => AdminLayoutRoute
          })
const AdminLayoutAdminSalesPitchesRoute = AdminLayoutAdminSalesPitchesRouteImport.update({
            id: '/admin/sales-pitches',path: '/admin/sales-pitches',getParentRoute: () => AdminLayoutRoute
          })
const AdminLayoutAdminSettingsRoute = AdminLayoutAdminSettingsRouteImport.update({
            id: '/admin/settings',path: '/admin/settings',getParentRoute: () => AdminLayoutRoute
          })
const AdminLayoutAdminStockPicturesRoute = AdminLayoutAdminStockPicturesRouteImport.update({
            id: '/admin/stock-pictures',path: '/admin/stock-pictures',getParentRoute: () => AdminLayoutRoute
          })
const AdminLayoutAdminStockPicturesReviewRoute = AdminLayoutAdminStockPicturesReviewRouteImport.update({
            id: '/admin/stock-pictures-review',path: '/admin/stock-pictures-review',getParentRoute: () => AdminLayoutRoute
          })
const AdminLayoutAdminThemesRoute = AdminLayoutAdminThemesRouteImport.update({
            id: '/admin/themes',path: '/admin/themes',getParentRoute: () => AdminLayoutRoute
          })
const AdminLayoutAdminUsersRoute = AdminLayoutAdminUsersRouteImport.update({
            id: '/admin/users',path: '/admin/users',getParentRoute: () => AdminLayoutRoute
          })
const AdminLayoutAdminVideoPagesRoute = AdminLayoutAdminVideoPagesRouteImport.update({
            id: '/admin/video-pages',path: '/admin/video-pages',getParentRoute: () => AdminLayoutRoute
          })
const NewProductTypeFeatureRoute = NewProductTypeFeatureRouteImport.update({
            id: '/$feature',path: '/$feature',getParentRoute: () => NewProductTypeRoute
          })
const PartsCatalogAccountForgotPasswordRoute = PartsCatalogAccountForgotPasswordRouteImport.update({
            id: '/account/forgot-password',path: '/account/forgot-password',getParentRoute: () => PartsCatalogRoute
          })
const PartsCatalogAccountLoginRoute = PartsCatalogAccountLoginRouteImport.update({
            id: '/account/login',path: '/account/login',getParentRoute: () => PartsCatalogRoute
          })
const PartsCatalogAccountRegisterRoute = PartsCatalogAccountRegisterRouteImport.update({
            id: '/account/register',path: '/account/register',getParentRoute: () => PartsCatalogRoute
          })
const PartsCatalogAccountResetPasswordRoute = PartsCatalogAccountResetPasswordRouteImport.update({
            id: '/account/reset-password',path: '/account/reset-password',getParentRoute: () => PartsCatalogRoute
          })
const PartsCatalogAccountVerifyRoute = PartsCatalogAccountVerifyRouteImport.update({
            id: '/account/verify',path: '/account/verify',getParentRoute: () => PartsCatalogRoute
          })
const PartsCatalogCategorySlugRoute = PartsCatalogCategorySlugRouteImport.update({
            id: '/category/$slug',path: '/category/$slug',getParentRoute: () => PartsCatalogRoute
          })
const PartsCatalogCheckoutIndexRoute = PartsCatalogCheckoutIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => PartsCatalogCheckoutRoute
          })
const PartsCatalogDocsIdRoute = PartsCatalogDocsIdRouteImport.update({
            id: '/docs/$id',path: '/docs/$id',getParentRoute: () => PartsCatalogRoute
          })
const PartsCatalogManufacturerSlugRoute = PartsCatalogManufacturerSlugRouteImport.update({
            id: '/manufacturer/$slug',path: '/manufacturer/$slug',getParentRoute: () => PartsCatalogRoute
          })
const PartsCatalogOrderOrderNumberRoute = PartsCatalogOrderOrderNumberRouteImport.update({
            id: '/order/$orderNumber',path: '/order/$orderNumber',getParentRoute: () => PartsCatalogRoute
          })
const PartsCatalogPageSlugRoute = PartsCatalogPageSlugRouteImport.update({
            id: '/page/$slug',path: '/page/$slug',getParentRoute: () => PartsCatalogRoute
          })
const PartsCatalogQuoteTokenRoute = PartsCatalogQuoteTokenRouteImport.update({
            id: '/quote/$token',path: '/quote/$token',getParentRoute: () => PartsCatalogRoute
          })
const PreviewRvSlugRoute = PreviewRvSlugRouteImport.update({
            id: '/preview/rv/$slug',path: '/preview/rv/$slug',getParentRoute: () => rootRouteImport
          })
const PrintStickerSlugRoute = PrintStickerSlugRouteImport.update({
            id: '/print/sticker/$slug',path: '/print/sticker/$slug',getParentRoute: () => rootRouteImport
          })
const ProductEastToWestPathTrimRoute = ProductEastToWestPathTrimRouteImport.update({
            id: '/$trim',path: '/$trim',getParentRoute: () => ProductEastToWestPathRoute
          })
const ProductForestRiverRvPathTrimRoute = ProductForestRiverRvPathTrimRouteImport.update({
            id: '/$trim',path: '/$trim',getParentRoute: () => ProductForestRiverRvPathRoute
          })
const ProductIntechRvPathTrimRoute = ProductIntechRvPathTrimRouteImport.update({
            id: '/$trim',path: '/$trim',getParentRoute: () => ProductIntechRvPathRoute
          })
const ProductPalominoPathTrimRoute = ProductPalominoPathTrimRouteImport.update({
            id: '/$trim',path: '/$trim',getParentRoute: () => ProductPalominoPathRoute
          })
const ProductSunseekerPathTrimRoute = ProductSunseekerPathTrimRouteImport.update({
            id: '/$trim',path: '/$trim',getParentRoute: () => ProductSunseekerPathRoute
          })
const ProductSlugIndexRoute = ProductSlugIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => ProductSlugRoute
          })
const ProductSlugFeatureRoute = ProductSlugFeatureRouteImport.update({
            id: '/$feature',path: '/$feature',getParentRoute: () => ProductSlugRoute
          })
const UsedProductTypeFeatureRoute = UsedProductTypeFeatureRouteImport.update({
            id: '/$feature',path: '/$feature',getParentRoute: () => UsedProductTypeRoute
          })
const AdminLayoutAdminPartsIndexRoute = AdminLayoutAdminPartsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AdminLayoutAdminPartsRoute
          })
const AdminLayoutAdminPartsProductIdRoute = AdminLayoutAdminPartsProductIdRouteImport.update({
            id: '/$productId',path: '/$productId',getParentRoute: () => AdminLayoutAdminPartsRoute
          })
const AdminLayoutAdminPartsCategoriesRoute = AdminLayoutAdminPartsCategoriesRouteImport.update({
            id: '/categories',path: '/categories',getParentRoute: () => AdminLayoutAdminPartsRoute
          })
const AdminLayoutAdminPartsCategoryMapperRoute = AdminLayoutAdminPartsCategoryMapperRouteImport.update({
            id: '/category-mapper',path: '/category-mapper',getParentRoute: () => AdminLayoutAdminPartsRoute
          })
const AdminLayoutAdminPartsChatsRoute = AdminLayoutAdminPartsChatsRouteImport.update({
            id: '/chats',path: '/chats',getParentRoute: () => AdminLayoutAdminPartsRoute
          })
const AdminLayoutAdminPartsContentRoute = AdminLayoutAdminPartsContentRouteImport.update({
            id: '/content',path: '/content',getParentRoute: () => AdminLayoutAdminPartsRoute
          })
const AdminLayoutAdminPartsCrmRoute = AdminLayoutAdminPartsCrmRouteImport.update({
            id: '/crm',path: '/crm',getParentRoute: () => AdminLayoutAdminPartsRoute
          })
const AdminLayoutAdminPartsCustomersRoute = AdminLayoutAdminPartsCustomersRouteImport.update({
            id: '/customers',path: '/customers',getParentRoute: () => AdminLayoutAdminPartsRoute
          })
const AdminLayoutAdminPartsDiscountsRoute = AdminLayoutAdminPartsDiscountsRouteImport.update({
            id: '/discounts',path: '/discounts',getParentRoute: () => AdminLayoutAdminPartsRoute
          })
const AdminLayoutAdminPartsDistributorsRoute = AdminLayoutAdminPartsDistributorsRouteImport.update({
            id: '/distributors',path: '/distributors',getParentRoute: () => AdminLayoutAdminPartsRoute
          })
const AdminLayoutAdminPartsEmailsRoute = AdminLayoutAdminPartsEmailsRouteImport.update({
            id: '/emails',path: '/emails',getParentRoute: () => AdminLayoutAdminPartsRoute
          })
const AdminLayoutAdminPartsFeedImportRoute = AdminLayoutAdminPartsFeedImportRouteImport.update({
            id: '/feed-import',path: '/feed-import',getParentRoute: () => AdminLayoutAdminPartsRoute
          })
const AdminLayoutAdminPartsMainCategoriesRoute = AdminLayoutAdminPartsMainCategoriesRouteImport.update({
            id: '/main-categories',path: '/main-categories',getParentRoute: () => AdminLayoutAdminPartsRoute
          })
const AdminLayoutAdminPartsManufacturersRoute = AdminLayoutAdminPartsManufacturersRouteImport.update({
            id: '/manufacturers',path: '/manufacturers',getParentRoute: () => AdminLayoutAdminPartsRoute
          })
const AdminLayoutAdminPartsMessagesRoute = AdminLayoutAdminPartsMessagesRouteImport.update({
            id: '/messages',path: '/messages',getParentRoute: () => AdminLayoutAdminPartsRoute
          })
const AdminLayoutAdminPartsNewsRoute = AdminLayoutAdminPartsNewsRouteImport.update({
            id: '/news',path: '/news',getParentRoute: () => AdminLayoutAdminPartsRoute
          })
const AdminLayoutAdminPartsOrdersRoute = AdminLayoutAdminPartsOrdersRouteImport.update({
            id: '/orders',path: '/orders',getParentRoute: () => AdminLayoutAdminPartsRoute
          })
const AdminLayoutAdminPartsQuotesRoute = AdminLayoutAdminPartsQuotesRouteImport.update({
            id: '/quotes',path: '/quotes',getParentRoute: () => AdminLayoutAdminPartsRoute
          })
const AdminLayoutAdminPartsRequestsRoute = AdminLayoutAdminPartsRequestsRouteImport.update({
            id: '/requests',path: '/requests',getParentRoute: () => AdminLayoutAdminPartsRoute
          })
const AdminLayoutAdminPartsReviewsRoute = AdminLayoutAdminPartsReviewsRouteImport.update({
            id: '/reviews',path: '/reviews',getParentRoute: () => AdminLayoutAdminPartsRoute
          })
const AdminLayoutAdminPartsShipmentsRoute = AdminLayoutAdminPartsShipmentsRouteImport.update({
            id: '/shipments',path: '/shipments',getParentRoute: () => AdminLayoutAdminPartsRoute
          })
const AdminLayoutAdminPartsStorefrontRoute = AdminLayoutAdminPartsStorefrontRouteImport.update({
            id: '/storefront',path: '/storefront',getParentRoute: () => AdminLayoutAdminPartsRoute
          })
const AdminLayoutAdminPartsTasksRoute = AdminLayoutAdminPartsTasksRouteImport.update({
            id: '/tasks',path: '/tasks',getParentRoute: () => AdminLayoutAdminPartsRoute
          })
const AdminLayoutAdminPartsTaxRatesRoute = AdminLayoutAdminPartsTaxRatesRouteImport.update({
            id: '/tax-rates',path: '/tax-rates',getParentRoute: () => AdminLayoutAdminPartsRoute
          })
const AdminLayoutAdminPartsTemplateRoute = AdminLayoutAdminPartsTemplateRouteImport.update({
            id: '/template',path: '/template',getParentRoute: () => AdminLayoutAdminPartsRoute
          })
const PartsAuthPartsCatalogAccountIndexRoute = PartsAuthPartsCatalogAccountIndexRouteImport.update({
            id: '/parts-catalog/account/',path: '/parts-catalog/account/',getParentRoute: () => PartsAuthRoute
          })
const PartsAuthPartsCatalogAccountAddressesRoute = PartsAuthPartsCatalogAccountAddressesRouteImport.update({
            id: '/parts-catalog/account/addresses',path: '/parts-catalog/account/addresses',getParentRoute: () => PartsAuthRoute
          })
const PartsAuthPartsCatalogAccountChangePasswordRoute = PartsAuthPartsCatalogAccountChangePasswordRouteImport.update({
            id: '/parts-catalog/account/change-password',path: '/parts-catalog/account/change-password',getParentRoute: () => PartsAuthRoute
          })
const PartsAuthPartsCatalogAccountOrdersRoute = PartsAuthPartsCatalogAccountOrdersRouteImport.update({
            id: '/parts-catalog/account/orders',path: '/parts-catalog/account/orders',getParentRoute: () => PartsAuthRoute
          })
const PartsCatalogCheckoutConfirmationOrderNumberRoute = PartsCatalogCheckoutConfirmationOrderNumberRouteImport.update({
            id: '/confirmation/$orderNumber',path: '/confirmation/$orderNumber',getParentRoute: () => PartsCatalogCheckoutRoute
          })
const AdminLayoutAdminPartsCategoriesIndexRoute = AdminLayoutAdminPartsCategoriesIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AdminLayoutAdminPartsCategoriesRoute
          })
const AdminLayoutAdminPartsCategoriesBasicCategoryRoute = AdminLayoutAdminPartsCategoriesBasicCategoryRouteImport.update({
            id: '/$basicCategory',path: '/$basicCategory',getParentRoute: () => AdminLayoutAdminPartsCategoriesRoute
          })
const AdminLayoutAdminPartsContentIndexRoute = AdminLayoutAdminPartsContentIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AdminLayoutAdminPartsContentRoute
          })
const AdminLayoutAdminPartsContentIdRoute = AdminLayoutAdminPartsContentIdRouteImport.update({
            id: '/$id',path: '/$id',getParentRoute: () => AdminLayoutAdminPartsContentRoute
          })
const AdminLayoutAdminPartsContentNewRoute = AdminLayoutAdminPartsContentNewRouteImport.update({
            id: '/new',path: '/new',getParentRoute: () => AdminLayoutAdminPartsContentRoute
          })
const AdminLayoutAdminPartsCustomersIndexRoute = AdminLayoutAdminPartsCustomersIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AdminLayoutAdminPartsCustomersRoute
          })
const AdminLayoutAdminPartsCustomersIdRoute = AdminLayoutAdminPartsCustomersIdRouteImport.update({
            id: '/$id',path: '/$id',getParentRoute: () => AdminLayoutAdminPartsCustomersRoute
          })
const AdminLayoutAdminPartsDiscountsIndexRoute = AdminLayoutAdminPartsDiscountsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AdminLayoutAdminPartsDiscountsRoute
          })
const AdminLayoutAdminPartsDiscountsIdRoute = AdminLayoutAdminPartsDiscountsIdRouteImport.update({
            id: '/$id',path: '/$id',getParentRoute: () => AdminLayoutAdminPartsDiscountsRoute
          })
const AdminLayoutAdminPartsDistributorsIndexRoute = AdminLayoutAdminPartsDistributorsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AdminLayoutAdminPartsDistributorsRoute
          })
const AdminLayoutAdminPartsDistributorsIdRoute = AdminLayoutAdminPartsDistributorsIdRouteImport.update({
            id: '/$id',path: '/$id',getParentRoute: () => AdminLayoutAdminPartsDistributorsRoute
          })
const AdminLayoutAdminPartsDistributorsNewRoute = AdminLayoutAdminPartsDistributorsNewRouteImport.update({
            id: '/new',path: '/new',getParentRoute: () => AdminLayoutAdminPartsDistributorsRoute
          })
const AdminLayoutAdminPartsManufacturersIndexRoute = AdminLayoutAdminPartsManufacturersIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AdminLayoutAdminPartsManufacturersRoute
          })
const AdminLayoutAdminPartsManufacturersVendorIdRoute = AdminLayoutAdminPartsManufacturersVendorIdRouteImport.update({
            id: '/$vendorId',path: '/$vendorId',getParentRoute: () => AdminLayoutAdminPartsManufacturersRoute
          })
const AdminLayoutAdminPartsMessagesIndexRoute = AdminLayoutAdminPartsMessagesIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AdminLayoutAdminPartsMessagesRoute
          })
const AdminLayoutAdminPartsMessagesIdRoute = AdminLayoutAdminPartsMessagesIdRouteImport.update({
            id: '/$id',path: '/$id',getParentRoute: () => AdminLayoutAdminPartsMessagesRoute
          })
const AdminLayoutAdminPartsNewsIndexRoute = AdminLayoutAdminPartsNewsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AdminLayoutAdminPartsNewsRoute
          })
const AdminLayoutAdminPartsNewsIdRoute = AdminLayoutAdminPartsNewsIdRouteImport.update({
            id: '/$id',path: '/$id',getParentRoute: () => AdminLayoutAdminPartsNewsRoute
          })
const AdminLayoutAdminPartsOrdersIndexRoute = AdminLayoutAdminPartsOrdersIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AdminLayoutAdminPartsOrdersRoute
          })
const AdminLayoutAdminPartsOrdersIdRoute = AdminLayoutAdminPartsOrdersIdRouteImport.update({
            id: '/$id',path: '/$id',getParentRoute: () => AdminLayoutAdminPartsOrdersRoute
          })
const AdminLayoutAdminPartsShipmentsIndexRoute = AdminLayoutAdminPartsShipmentsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AdminLayoutAdminPartsShipmentsRoute
          })
const AdminLayoutAdminPartsShipmentsIdRoute = AdminLayoutAdminPartsShipmentsIdRouteImport.update({
            id: '/$id',path: '/$id',getParentRoute: () => AdminLayoutAdminPartsShipmentsRoute
          })





const AdminLayoutAdminPartsCategoriesRouteChildren = {
  AdminLayoutAdminPartsCategoriesBasicCategoryRoute: AdminLayoutAdminPartsCategoriesBasicCategoryRoute,AdminLayoutAdminPartsCategoriesIndexRoute: AdminLayoutAdminPartsCategoriesIndexRoute
}

const AdminLayoutAdminPartsCategoriesRouteWithChildren = AdminLayoutAdminPartsCategoriesRoute._addFileChildren(AdminLayoutAdminPartsCategoriesRouteChildren)




const AdminLayoutAdminPartsContentRouteChildren = {
  AdminLayoutAdminPartsContentIdRoute: AdminLayoutAdminPartsContentIdRoute,AdminLayoutAdminPartsContentNewRoute: AdminLayoutAdminPartsContentNewRoute,AdminLayoutAdminPartsContentIndexRoute: AdminLayoutAdminPartsContentIndexRoute
}

const AdminLayoutAdminPartsContentRouteWithChildren = AdminLayoutAdminPartsContentRoute._addFileChildren(AdminLayoutAdminPartsContentRouteChildren)




const AdminLayoutAdminPartsCustomersRouteChildren = {
  AdminLayoutAdminPartsCustomersIdRoute: AdminLayoutAdminPartsCustomersIdRoute,AdminLayoutAdminPartsCustomersIndexRoute: AdminLayoutAdminPartsCustomersIndexRoute
}

const AdminLayoutAdminPartsCustomersRouteWithChildren = AdminLayoutAdminPartsCustomersRoute._addFileChildren(AdminLayoutAdminPartsCustomersRouteChildren)




const AdminLayoutAdminPartsDiscountsRouteChildren = {
  AdminLayoutAdminPartsDiscountsIdRoute: AdminLayoutAdminPartsDiscountsIdRoute,AdminLayoutAdminPartsDiscountsIndexRoute: AdminLayoutAdminPartsDiscountsIndexRoute
}

const AdminLayoutAdminPartsDiscountsRouteWithChildren = AdminLayoutAdminPartsDiscountsRoute._addFileChildren(AdminLayoutAdminPartsDiscountsRouteChildren)




const AdminLayoutAdminPartsDistributorsRouteChildren = {
  AdminLayoutAdminPartsDistributorsIdRoute: AdminLayoutAdminPartsDistributorsIdRoute,AdminLayoutAdminPartsDistributorsNewRoute: AdminLayoutAdminPartsDistributorsNewRoute,AdminLayoutAdminPartsDistributorsIndexRoute: AdminLayoutAdminPartsDistributorsIndexRoute
}

const AdminLayoutAdminPartsDistributorsRouteWithChildren = AdminLayoutAdminPartsDistributorsRoute._addFileChildren(AdminLayoutAdminPartsDistributorsRouteChildren)




const AdminLayoutAdminPartsManufacturersRouteChildren = {
  AdminLayoutAdminPartsManufacturersVendorIdRoute: AdminLayoutAdminPartsManufacturersVendorIdRoute,AdminLayoutAdminPartsManufacturersIndexRoute: AdminLayoutAdminPartsManufacturersIndexRoute
}

const AdminLayoutAdminPartsManufacturersRouteWithChildren = AdminLayoutAdminPartsManufacturersRoute._addFileChildren(AdminLayoutAdminPartsManufacturersRouteChildren)




const AdminLayoutAdminPartsMessagesRouteChildren = {
  AdminLayoutAdminPartsMessagesIdRoute: AdminLayoutAdminPartsMessagesIdRoute,AdminLayoutAdminPartsMessagesIndexRoute: AdminLayoutAdminPartsMessagesIndexRoute
}

const AdminLayoutAdminPartsMessagesRouteWithChildren = AdminLayoutAdminPartsMessagesRoute._addFileChildren(AdminLayoutAdminPartsMessagesRouteChildren)




const AdminLayoutAdminPartsNewsRouteChildren = {
  AdminLayoutAdminPartsNewsIdRoute: AdminLayoutAdminPartsNewsIdRoute,AdminLayoutAdminPartsNewsIndexRoute: AdminLayoutAdminPartsNewsIndexRoute
}

const AdminLayoutAdminPartsNewsRouteWithChildren = AdminLayoutAdminPartsNewsRoute._addFileChildren(AdminLayoutAdminPartsNewsRouteChildren)




const AdminLayoutAdminPartsOrdersRouteChildren = {
  AdminLayoutAdminPartsOrdersIdRoute: AdminLayoutAdminPartsOrdersIdRoute,AdminLayoutAdminPartsOrdersIndexRoute: AdminLayoutAdminPartsOrdersIndexRoute
}

const AdminLayoutAdminPartsOrdersRouteWithChildren = AdminLayoutAdminPartsOrdersRoute._addFileChildren(AdminLayoutAdminPartsOrdersRouteChildren)




const AdminLayoutAdminPartsShipmentsRouteChildren = {
  AdminLayoutAdminPartsShipmentsIdRoute: AdminLayoutAdminPartsShipmentsIdRoute,AdminLayoutAdminPartsShipmentsIndexRoute: AdminLayoutAdminPartsShipmentsIndexRoute
}

const AdminLayoutAdminPartsShipmentsRouteWithChildren = AdminLayoutAdminPartsShipmentsRoute._addFileChildren(AdminLayoutAdminPartsShipmentsRouteChildren)



const AdminLayoutAdminPartsRouteChildren = {
  AdminLayoutAdminPartsProductIdRoute: AdminLayoutAdminPartsProductIdRoute,AdminLayoutAdminPartsCategoriesRoute: AdminLayoutAdminPartsCategoriesRouteWithChildren,AdminLayoutAdminPartsCategoryMapperRoute: AdminLayoutAdminPartsCategoryMapperRoute,AdminLayoutAdminPartsChatsRoute: AdminLayoutAdminPartsChatsRoute,AdminLayoutAdminPartsContentRoute: AdminLayoutAdminPartsContentRouteWithChildren,AdminLayoutAdminPartsCrmRoute: AdminLayoutAdminPartsCrmRoute,AdminLayoutAdminPartsCustomersRoute: AdminLayoutAdminPartsCustomersRouteWithChildren,AdminLayoutAdminPartsDiscountsRoute: AdminLayoutAdminPartsDiscountsRouteWithChildren,AdminLayoutAdminPartsDistributorsRoute: AdminLayoutAdminPartsDistributorsRouteWithChildren,AdminLayoutAdminPartsEmailsRoute: AdminLayoutAdminPartsEmailsRoute,AdminLayoutAdminPartsFeedImportRoute: AdminLayoutAdminPartsFeedImportRoute,AdminLayoutAdminPartsMainCategoriesRoute: AdminLayoutAdminPartsMainCategoriesRoute,AdminLayoutAdminPartsManufacturersRoute: AdminLayoutAdminPartsManufacturersRouteWithChildren,AdminLayoutAdminPartsMessagesRoute: AdminLayoutAdminPartsMessagesRouteWithChildren,AdminLayoutAdminPartsNewsRoute: AdminLayoutAdminPartsNewsRouteWithChildren,AdminLayoutAdminPartsOrdersRoute: AdminLayoutAdminPartsOrdersRouteWithChildren,AdminLayoutAdminPartsQuotesRoute: AdminLayoutAdminPartsQuotesRoute,AdminLayoutAdminPartsRequestsRoute: AdminLayoutAdminPartsRequestsRoute,AdminLayoutAdminPartsReviewsRoute: AdminLayoutAdminPartsReviewsRoute,AdminLayoutAdminPartsShipmentsRoute: AdminLayoutAdminPartsShipmentsRouteWithChildren,AdminLayoutAdminPartsStorefrontRoute: AdminLayoutAdminPartsStorefrontRoute,AdminLayoutAdminPartsTasksRoute: AdminLayoutAdminPartsTasksRoute,AdminLayoutAdminPartsTaxRatesRoute: AdminLayoutAdminPartsTaxRatesRoute,AdminLayoutAdminPartsTemplateRoute: AdminLayoutAdminPartsTemplateRoute,AdminLayoutAdminPartsIndexRoute: AdminLayoutAdminPartsIndexRoute
}

const AdminLayoutAdminPartsRouteWithChildren = AdminLayoutAdminPartsRoute._addFileChildren(AdminLayoutAdminPartsRouteChildren)



const AdminLayoutRouteChildren = {
  AdminLayoutAdminAdsRoute: AdminLayoutAdminAdsRoute,AdminLayoutAdminAppointmentsRoute: AdminLayoutAdminAppointmentsRoute,AdminLayoutAdminBlogRoute: AdminLayoutAdminBlogRoute,AdminLayoutAdminBuyersGuideRoute: AdminLayoutAdminBuyersGuideRoute,AdminLayoutAdminCarmaxImagesRoute: AdminLayoutAdminCarmaxImagesRoute,AdminLayoutAdminChatSandboxRoute: AdminLayoutAdminChatSandboxRoute,AdminLayoutAdminChatsRoute: AdminLayoutAdminChatsRoute,AdminLayoutAdminCrmRoute: AdminLayoutAdminCrmRoute,AdminLayoutAdminCronJobsRoute: AdminLayoutAdminCronJobsRoute,AdminLayoutAdminCustomerPortalRoute: AdminLayoutAdminCustomerPortalRoute,AdminLayoutAdminEmailRoute: AdminLayoutAdminEmailRoute,AdminLayoutAdminFeedDownloadsRoute: AdminLayoutAdminFeedDownloadsRoute,AdminLayoutAdminFeedImportRoute: AdminLayoutAdminFeedImportRoute,AdminLayoutAdminFloorplanImportRoute: AdminLayoutAdminFloorplanImportRoute,AdminLayoutAdminGuidesRoute: AdminLayoutAdminGuidesRoute,AdminLayoutAdminImageAuditRoute: AdminLayoutAdminImageAuditRoute,AdminLayoutAdminInventoryRoute: AdminLayoutAdminInventoryRoute,AdminLayoutAdminInventoryCleanSyncRoute: AdminLayoutAdminInventoryCleanSyncRoute,AdminLayoutAdminInventoryStageSyncRoute: AdminLayoutAdminInventoryStageSyncRoute,AdminLayoutAdminKellerTestRoute: AdminLayoutAdminKellerTestRoute,AdminLayoutAdminKeystoneDiscontinuedRoute: AdminLayoutAdminKeystoneDiscontinuedRoute,AdminLayoutAdminKioskRoute: AdminLayoutAdminKioskRoute,AdminLayoutAdminLibraryRoute: AdminLayoutAdminLibraryRoute,AdminLayoutAdminLoyaltyRoute: AdminLayoutAdminLoyaltyRoute,AdminLayoutAdminMarketingRoute: AdminLayoutAdminMarketingRoute,AdminLayoutAdminMenuRoute: AdminLayoutAdminMenuRoute,AdminLayoutAdminMicrositesRoute: AdminLayoutAdminMicrositesRoute,AdminLayoutAdminMssqlSyncRoute: AdminLayoutAdminMssqlSyncRoute,AdminLayoutAdminNewslettersRoute: AdminLayoutAdminNewslettersRoute,AdminLayoutAdminPagesRoute: AdminLayoutAdminPagesRoute,AdminLayoutAdminPartsRoute: AdminLayoutAdminPartsRouteWithChildren,AdminLayoutAdminPartsFeedRoute: AdminLayoutAdminPartsFeedRoute,AdminLayoutAdminPartsSearchTestRoute: AdminLayoutAdminPartsSearchTestRoute,AdminLayoutAdminPartsSyncRoute: AdminLayoutAdminPartsSyncRoute,AdminLayoutAdminPricingRoute: AdminLayoutAdminPricingRoute,AdminLayoutAdminRedirectsRoute: AdminLayoutAdminRedirectsRoute,AdminLayoutAdminRentalsRoute: AdminLayoutAdminRentalsRoute,AdminLayoutAdminReviewsRoute: AdminLayoutAdminReviewsRoute,AdminLayoutAdminSalesPitchesRoute: AdminLayoutAdminSalesPitchesRoute,AdminLayoutAdminSettingsRoute: AdminLayoutAdminSettingsRoute,AdminLayoutAdminStockPicturesRoute: AdminLayoutAdminStockPicturesRoute,AdminLayoutAdminStockPicturesReviewRoute: AdminLayoutAdminStockPicturesReviewRoute,AdminLayoutAdminThemesRoute: AdminLayoutAdminThemesRoute,AdminLayoutAdminUsersRoute: AdminLayoutAdminUsersRoute,AdminLayoutAdminVideoPagesRoute: AdminLayoutAdminVideoPagesRoute,AdminLayoutAdminIndexRoute: AdminLayoutAdminIndexRoute
}

const AdminLayoutRouteWithChildren = AdminLayoutRoute._addFileChildren(AdminLayoutRouteChildren)




const PartsAuthRouteChildren = {
  PartsAuthPartsCatalogAccountAddressesRoute: PartsAuthPartsCatalogAccountAddressesRoute,PartsAuthPartsCatalogAccountChangePasswordRoute: PartsAuthPartsCatalogAccountChangePasswordRoute,PartsAuthPartsCatalogAccountOrdersRoute: PartsAuthPartsCatalogAccountOrdersRoute,PartsAuthPartsCatalogAccountIndexRoute: PartsAuthPartsCatalogAccountIndexRoute
}

const PartsAuthRouteWithChildren = PartsAuthRoute._addFileChildren(PartsAuthRouteChildren)




const BlogRouteChildren = {
  BlogSlugRoute: BlogSlugRoute,BlogIndexRoute: BlogIndexRoute
}

const BlogRouteWithChildren = BlogRoute._addFileChildren(BlogRouteChildren)




const ForumRouteChildren = {
  ForumSlugRoute: ForumSlugRoute,ForumIndexRoute: ForumIndexRoute
}

const ForumRouteWithChildren = ForumRoute._addFileChildren(ForumRouteChildren)




const GuideRouteChildren = {
  GuideSlugRoute: GuideSlugRoute,GuideIndexRoute: GuideIndexRoute
}

const GuideRouteWithChildren = GuideRoute._addFileChildren(GuideRouteChildren)




const InventoryRouteChildren = {
  InventorySlugRoute: InventorySlugRoute
}

const InventoryRouteWithChildren = InventoryRoute._addFileChildren(InventoryRouteChildren)




const MyAccountRouteChildren = {
  MyAccountNotificationsRoute: MyAccountNotificationsRoute,MyAccountProfileRoute: MyAccountProfileRoute,MyAccountRewardsRoute: MyAccountRewardsRoute,MyAccountRvsRoute: MyAccountRvsRoute,MyAccountServiceRoute: MyAccountServiceRoute,MyAccountWishlistRoute: MyAccountWishlistRoute,MyAccountIndexRoute: MyAccountIndexRoute
}

const MyAccountRouteWithChildren = MyAccountRoute._addFileChildren(MyAccountRouteChildren)




const NcFreedomPopupDealerRouteChildren = {
  NcFreedomPopupDealerSlugRoute: NcFreedomPopupDealerSlugRoute,NcFreedomPopupDealerIndexRoute: NcFreedomPopupDealerIndexRoute
}

const NcFreedomPopupDealerRouteWithChildren = NcFreedomPopupDealerRoute._addFileChildren(NcFreedomPopupDealerRouteChildren)




const NcPumaDealerRouteChildren = {
  NcPumaDealerSlugRoute: NcPumaDealerSlugRoute,NcPumaDealerIndexRoute: NcPumaDealerIndexRoute
}

const NcPumaDealerRouteWithChildren = NcPumaDealerRoute._addFileChildren(NcPumaDealerRouteChildren)




const NewProductTypeRouteChildren = {
  NewProductTypeFeatureRoute: NewProductTypeFeatureRoute
}

const NewProductTypeRouteWithChildren = NewProductTypeRoute._addFileChildren(NewProductTypeRouteChildren)



const NewProductRouteChildren = {
  NewProductTypeRoute: NewProductTypeRouteWithChildren,NewProductIndexRoute: NewProductIndexRoute
}

const NewProductRouteWithChildren = NewProductRoute._addFileChildren(NewProductRouteChildren)




const PartsCatalogCheckoutRouteChildren = {
  PartsCatalogCheckoutIndexRoute: PartsCatalogCheckoutIndexRoute,PartsCatalogCheckoutConfirmationOrderNumberRoute: PartsCatalogCheckoutConfirmationOrderNumberRoute
}

const PartsCatalogCheckoutRouteWithChildren = PartsCatalogCheckoutRoute._addFileChildren(PartsCatalogCheckoutRouteChildren)



const PartsCatalogRouteChildren = {
  PartsCatalogIdRoute: PartsCatalogIdRoute,PartsCatalogCartRoute: PartsCatalogCartRoute,PartsCatalogCategoriesRoute: PartsCatalogCategoriesRoute,PartsCatalogCheckoutRoute: PartsCatalogCheckoutRouteWithChildren,PartsCatalogManufacturersRoute: PartsCatalogManufacturersRoute,PartsCatalogPrivacyNoticeRoute: PartsCatalogPrivacyNoticeRoute,PartsCatalogResultsRoute: PartsCatalogResultsRoute,PartsCatalogShippingReturnsRoute: PartsCatalogShippingReturnsRoute,PartsCatalogUnsubscribeRoute: PartsCatalogUnsubscribeRoute,PartsCatalogIndexRoute: PartsCatalogIndexRoute,PartsCatalogAccountForgotPasswordRoute: PartsCatalogAccountForgotPasswordRoute,PartsCatalogAccountLoginRoute: PartsCatalogAccountLoginRoute,PartsCatalogAccountRegisterRoute: PartsCatalogAccountRegisterRoute,PartsCatalogAccountResetPasswordRoute: PartsCatalogAccountResetPasswordRoute,PartsCatalogAccountVerifyRoute: PartsCatalogAccountVerifyRoute,PartsCatalogCategorySlugRoute: PartsCatalogCategorySlugRoute,PartsCatalogDocsIdRoute: PartsCatalogDocsIdRoute,PartsCatalogManufacturerSlugRoute: PartsCatalogManufacturerSlugRoute,PartsCatalogOrderOrderNumberRoute: PartsCatalogOrderOrderNumberRoute,PartsCatalogPageSlugRoute: PartsCatalogPageSlugRoute,PartsCatalogQuoteTokenRoute: PartsCatalogQuoteTokenRoute
}

const PartsCatalogRouteWithChildren = PartsCatalogRoute._addFileChildren(PartsCatalogRouteChildren)




const ProductEastToWestPathRouteChildren = {
  ProductEastToWestPathTrimRoute: ProductEastToWestPathTrimRoute
}

const ProductEastToWestPathRouteWithChildren = ProductEastToWestPathRoute._addFileChildren(ProductEastToWestPathRouteChildren)



const ProductEastToWestRouteChildren = {
  ProductEastToWestPathRoute: ProductEastToWestPathRouteWithChildren,ProductEastToWestIndexRoute: ProductEastToWestIndexRoute
}

const ProductEastToWestRouteWithChildren = ProductEastToWestRoute._addFileChildren(ProductEastToWestRouteChildren)




const ProductForestRiverRvPathRouteChildren = {
  ProductForestRiverRvPathTrimRoute: ProductForestRiverRvPathTrimRoute
}

const ProductForestRiverRvPathRouteWithChildren = ProductForestRiverRvPathRoute._addFileChildren(ProductForestRiverRvPathRouteChildren)



const ProductForestRiverRvRouteChildren = {
  ProductForestRiverRvPathRoute: ProductForestRiverRvPathRouteWithChildren,ProductForestRiverRvIndexRoute: ProductForestRiverRvIndexRoute
}

const ProductForestRiverRvRouteWithChildren = ProductForestRiverRvRoute._addFileChildren(ProductForestRiverRvRouteChildren)




const ProductIntechRvPathRouteChildren = {
  ProductIntechRvPathTrimRoute: ProductIntechRvPathTrimRoute
}

const ProductIntechRvPathRouteWithChildren = ProductIntechRvPathRoute._addFileChildren(ProductIntechRvPathRouteChildren)



const ProductIntechRvRouteChildren = {
  ProductIntechRvPathRoute: ProductIntechRvPathRouteWithChildren,ProductIntechRvIndexRoute: ProductIntechRvIndexRoute
}

const ProductIntechRvRouteWithChildren = ProductIntechRvRoute._addFileChildren(ProductIntechRvRouteChildren)




const ProductPalominoPathRouteChildren = {
  ProductPalominoPathTrimRoute: ProductPalominoPathTrimRoute
}

const ProductPalominoPathRouteWithChildren = ProductPalominoPathRoute._addFileChildren(ProductPalominoPathRouteChildren)



const ProductPalominoRouteChildren = {
  ProductPalominoPathRoute: ProductPalominoPathRouteWithChildren,ProductPalominoIndexRoute: ProductPalominoIndexRoute
}

const ProductPalominoRouteWithChildren = ProductPalominoRoute._addFileChildren(ProductPalominoRouteChildren)




const ProductSunseekerPathRouteChildren = {
  ProductSunseekerPathTrimRoute: ProductSunseekerPathTrimRoute
}

const ProductSunseekerPathRouteWithChildren = ProductSunseekerPathRoute._addFileChildren(ProductSunseekerPathRouteChildren)



const ProductSunseekerRouteChildren = {
  ProductSunseekerPathRoute: ProductSunseekerPathRouteWithChildren,ProductSunseekerIndexRoute: ProductSunseekerIndexRoute
}

const ProductSunseekerRouteWithChildren = ProductSunseekerRoute._addFileChildren(ProductSunseekerRouteChildren)




const RvSearchRouteChildren = {
  RvSearchSlugRoute: RvSearchSlugRoute,RvSearchIndexRoute: RvSearchIndexRoute
}

const RvSearchRouteWithChildren = RvSearchRoute._addFileChildren(RvSearchRouteChildren)




const UsedProductTypeRouteChildren = {
  UsedProductTypeFeatureRoute: UsedProductTypeFeatureRoute
}

const UsedProductTypeRouteWithChildren = UsedProductTypeRoute._addFileChildren(UsedProductTypeRouteChildren)



const UsedProductRouteChildren = {
  UsedProductTypeRoute: UsedProductTypeRouteWithChildren,UsedProductIndexRoute: UsedProductIndexRoute
}

const UsedProductRouteWithChildren = UsedProductRoute._addFileChildren(UsedProductRouteChildren)




const VideosRouteChildren = {
  VideosSlugRoute: VideosSlugRoute,VideosIndexRoute: VideosIndexRoute
}

const VideosRouteWithChildren = VideosRoute._addFileChildren(VideosRouteChildren)




const ProductSlugRouteChildren = {
  ProductSlugFeatureRoute: ProductSlugFeatureRoute,ProductSlugIndexRoute: ProductSlugIndexRoute
}

const ProductSlugRouteWithChildren = ProductSlugRoute._addFileChildren(ProductSlugRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AdminLayoutRoute: AdminLayoutRouteWithChildren,PartsAuthRoute: PartsAuthRouteWithChildren,AboutRoute: AboutRoute,AboutUsRoute: AboutUsRoute,ApplicationCareerRoute: ApplicationCareerRoute,BlogRoute: BlogRouteWithChildren,CampingClubRoute: CampingClubRoute,CampingInWilmingtonNorthCarolinaRoute: CampingInWilmingtonNorthCarolinaRoute,ChatSandboxRoute: ChatSandboxRoute,CindySandboxRoute: CindySandboxRoute,CommunityLoginRoute: CommunityLoginRoute,ContactRoute: ContactRoute,ContactUsRoute: ContactUsRoute,ContactUsTradeInsRoute: ContactUsTradeInsRoute,DealOfTheWeekRoute: DealOfTheWeekRoute,DestinationTrailersRoute: DestinationTrailersRoute,DoorPrizesRoute: DoorPrizesRoute,FifthWheelsRoute: FifthWheelsRoute,FinancingRoute: FinancingRoute,ForumRoute: ForumRouteWithChildren,GuideRoute: GuideRouteWithChildren,InventoryRoute: InventoryRouteWithChildren,KioskRoute: KioskRoute,LoyaltyProgramRoute: LoyaltyProgramRoute,MeetRexRoute: MeetRexRoute,MotorhomesRoute: MotorhomesRoute,MyAccountRoute: MyAccountRouteWithChildren,NcFreedomPopupDealerRoute: NcFreedomPopupDealerRouteWithChildren,NcPumaDealerRoute: NcPumaDealerRouteWithChildren,NewProductRoute: NewProductRouteWithChildren,NewRvsRoute: NewRvsRoute,PartsRoute: PartsRoute,PartsCatalogRoute: PartsCatalogRouteWithChildren,PartsCatalogTestRoute: PartsCatalogTestRoute,PartsCindySandboxRoute: PartsCindySandboxRoute,PartsPreviewRoute: PartsPreviewRoute,PartsRequestRoute: PartsRequestRoute,PaymentCalculatorRoute: PaymentCalculatorRoute,PopUpCampersRoute: PopUpCampersRoute,PrivacyPolicyRoute: PrivacyPolicyRoute,ProductEastToWestRoute: ProductEastToWestRouteWithChildren,ProductForestRiverRvRoute: ProductForestRiverRvRouteWithChildren,ProductIntechRvRoute: ProductIntechRvRouteWithChildren,ProductPalominoRoute: ProductPalominoRouteWithChildren,ProductSunseekerRoute: ProductSunseekerRouteWithChildren,RaleighShowDrawingRoute: RaleighShowDrawingRoute,RentalsRoute: RentalsRoute,ResetPasswordRoute: ResetPasswordRoute,Route66RvNetworkRoute: Route66RvNetworkRoute,RvFinancingRoute: RvFinancingRoute,RvHowToCheckYourRoofSeals1Route: RvHowToCheckYourRoofSeals1Route,RvHowToWinterizeMyRvRoute: RvHowToWinterizeMyRvRoute,RvManualsRoute: RvManualsRoute,RvPartsRoute: RvPartsRoute,RvPreTripCheckListRoute: RvPreTripCheckListRoute,RvSearchRoute: RvSearchRouteWithChildren,RvSearchLabRoute: RvSearchLabRoute,RvServiceRoute: RvServiceRoute,ScheduleAppointmentRoute: ScheduleAppointmentRoute,SearchRoute: SearchRoute,SearchLabRoute: SearchLabRoute,SellMyRvRoute: SellMyRvRoute,SellYourRvRoute: SellYourRvRoute,ServiceRoute: ServiceRoute,ShopByBrandRoute: ShopByBrandRoute,ShopPartsRoute: ShopPartsRoute,SpringRvExpoRoute: SpringRvExpoRoute,TestimonialsRoute: TestimonialsRoute,TowGuideRoute: TowGuideRoute,TowGuidesRoute: TowGuidesRoute,ToyHaulersRoute: ToyHaulersRoute,TravelTrailersRoute: TravelTrailersRoute,UsedProductRoute: UsedProductRouteWithChildren,UsedRvsRoute: UsedRvsRoute,VideoGalleryRoute: VideoGalleryRoute,VideosRoute: VideosRouteWithChildren,WhyBuyAnRvRoute: WhyBuyAnRvRoute,AdminCrm360Route: AdminCrm360Route,AdminLoginRoute: AdminLoginRoute,BrochureTestSlugRoute: BrochureTestSlugRoute,PSlugRoute: PSlugRoute,PreviewHomeRoute: PreviewHomeRoute,ProductSlugRoute: ProductSlugRouteWithChildren,ProductKioskRoute: ProductKioskRoute,ProductsSlugRoute: ProductsSlugRoute,ProducttagSlugRoute: ProducttagSlugRoute,PreviewRvSlugRoute: PreviewRvSlugRoute,PrintStickerSlugRoute: PrintStickerSlugRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)